// Module
var code = "\n<fc-icon params=\"name: 'chevron-bottom'\" data-bind=\"attr: {\n  'data-open': open\n}\"></fc-icon>\n";
// Exports
module.exports = code;